import { CalendarDays, Check, ImageOff, PackageCheck, Scale } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { fileUrl } from "../../lib/fileUrl";
import { nomeProdottoDelLotto } from "./preparaUtils";

const formatDate = (value) => {
  if (!value) return "—";
  const [year, month, day] = value.slice(0, 10).split("-");
  return `${day}/${month}/${year}`;
};

const formatQuantity = ({ valore, unita }) => {
  const rounded = Math.round(valore * 1000) / 1000;
  return `${rounded.toLocaleString("it-IT")} ${unita}`;
};

export const LottiEsistentiDialog = ({ open, onOpenChange, ingrediente, items, ingredientiCatalogo = [], localeId, onSelect }) => {
  const richiesta = Number(ingrediente?.quantita_grammi) || 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[88vh] overflow-y-auto" data-testid="existing-lots-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" data-testid="existing-lots-title">
            <PackageCheck className="h-5 w-5 text-emerald-600" />
            Lotti disponibili
          </DialogTitle>
          <DialogDescription data-testid="existing-lots-description">
            Seleziona il lotto madre per {ingrediente?.ingrediente_nome}. La quantità prevista sarà scaricata al salvataggio.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3" data-testid="existing-lots-list">
          {items.map(({ lotto, quantita }) => {
            const scadenza = lotto.data_scadenza_aperto || lotto.data_scadenza;
            const insufficiente = quantita.quantitaBase + 0.000001 < richiesta;
            const nomeLotto = nomeProdottoDelLotto(lotto, ingredientiCatalogo, localeId);
            return (
              <div key={lotto.id} className="grid grid-cols-[72px_minmax(0,1fr)] gap-3 rounded-lg border p-3" data-testid={`existing-lot-card-${lotto.id}`}>
                <div className="aspect-square overflow-hidden rounded-md bg-muted">
                  {lotto.immagine_path ? (
                    <img
                      src={fileUrl(lotto.immagine_path)}
                      alt={`Etichetta lotto ${lotto.numero_lotto}`}
                      className="h-full w-full object-cover"
                      data-testid={`existing-lot-image-${lotto.id}`}
                    />
                  ) : (
                    <div className="flex h-full items-center justify-center text-muted-foreground" data-testid={`existing-lot-no-image-${lotto.id}`}>
                      <ImageOff className="h-5 w-5" />
                    </div>
                  )}
                </div>

                <div className="min-w-0">
                  <div className="flex flex-wrap items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <p className="text-base font-bold text-foreground break-words" data-testid={`existing-lot-product-name-${lotto.id}`}>
                        {nomeLotto || "Ingrediente non identificato"}
                      </p>
                      <p className="text-sm font-semibold text-foreground" data-testid={`existing-lot-number-${lotto.id}`}>
                        Lotto {lotto.numero_lotto || lotto.interno_lotto || "—"}
                      </p>
                      {lotto.interno_lotto && lotto.numero_lotto !== lotto.interno_lotto && (
                        <p className="text-xs text-muted-foreground">Codice interno {lotto.interno_lotto}</p>
                      )}
                    </div>
                    <span className="rounded-md bg-emerald-50 px-2 py-1 text-xs font-semibold text-emerald-700" data-testid={`existing-lot-status-${lotto.id}`}>
                      {(lotto.stato || "fresco") === "fresco"
                        ? (lotto.metodo_conservazione === "temp_ambiente" ? "Temp. ambiente" : "Frigo")
                        : lotto.stato}
                    </span>
                  </div>

                  <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground">
                    <span className="inline-flex items-center gap-1" data-testid={`existing-lot-quantity-${lotto.id}`}>
                      <Scale className="h-3.5 w-3.5" /> {formatQuantity(quantita)}
                    </span>
                    <span className="inline-flex items-center gap-1" data-testid={`existing-lot-expiry-${lotto.id}`}>
                      <CalendarDays className="h-3.5 w-3.5" /> {formatDate(scadenza)}
                    </span>
                  </div>

                  <Button
                    type="button"
                    size="sm"
                    className="mt-3 w-full sm:w-auto"
                    disabled={insufficiente || !nomeLotto}
                    onClick={() => onSelect(lotto, quantita, nomeLotto)}
                    data-testid={`select-existing-lot-${lotto.id}`}
                  >
                    <Check className="mr-2 h-4 w-4" />
                    {!nomeLotto ? "Lotto non identificato" : insufficiente ? "Quantità insufficiente" : "Usa questo lotto"}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="existing-lots-cancel-button">
          Continua con foto o dati manuali
        </Button>
      </DialogContent>
    </Dialog>
  );
};